var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{staticClass:"ma-0 pa-0",attrs:{"cols":"12"}},[_c('router-view',{attrs:{"users":_vm.users,"usersRequest":_vm.usersRequest}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }